import { authConfig } from "../apiConfig";

export const addReport = async (data) => {
    try {
        // const response = await authConfig.post(`FSEReporting`, data);
        const response = await authConfig.post(`FSEReportingwithOutassignement`, data);
        return response.data;
    } catch (error) {
        throw error;

    }
}

// FOR REPORT STTAUS CHANGE
export const changeReportStatus = async (data) => {
    try {
        let response = await authConfig.post('ScheduleReportAssigned', data)
        return response.data
    } catch (error) {
        throw error
    }
}


export const getReportsById = async (report_id) => {
    try {
        let response = await authConfig.post('getReportById', { reportId: report_id })
        return response.data
    } catch (error) {
        throw error
    }
}


// export const reportCompletionByReportIds = async (data) => {
//     try {
//         let response = await authConfig.post('ScheduleReportcompletion', data)
//         return response.data
//     } catch (error) {
//         throw error
//     }
// }
// NEW FUNCTION FOR REPORT COMPLETION 
export const reportCompletionByReportIds = async (data) => {
    try {
        let response = await authConfig.post('completeReport', data)
        return response.data
    } catch (error) {
        throw error
    }
}
// FOR REPORT REASSIGN CHANGE
export const reportReassign = async (data) => {
    try {
        let response = await authConfig.post('reports/reassignments', data)
        return response.data
    } catch (error) {
        throw error
    }
}



// FOR SCHEDULE ACCEPT/REJECT BY ADMIN/SUPERVISOR 
export const schedule_accept_rejectByAdmin = async (data) => {
    try {
        let response = await authConfig.post('ScheduleAcceptRejectByAdmin', data)
        return response.data
    } catch (error) {
        throw error
    }
}

// FOR ADD/REMOVE ENGINEEERS TO THE SCHEDULE AFTER SCHDELE CREATE
export const updateScheduleEngineers = async (data) => {
    try {
        let response = await authConfig.post('ScheduleEngineer/AddRemoveManage', data)
        return response.data
    } catch (error) {
        throw error
    }
}

// FOR ADD/REMOVE EQUIPMENTS TO THE SCHEDULE AFTER SCHDELE CREATE
export const updateScheduleEquipments = async (data) => {
    try {
        let response = await authConfig.post('ScheduleEquipment/AddRemoveByAdmin', data)
        return response.data
    } catch (error) {
        throw error
    }
}
